// extracted by mini-css-extract-plugin
module.exports = {"bottom-column-wapper":"gt","bottomColumnWapper":"gt","bottom-column-panel":"gu","bottomColumnPanel":"gu"};